/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { Advisor } from "./advisor"

export interface NoubaLightProject {
  id: number
  structure: string
  label: string
  holdersPreferredNames: Array<string>
  holdersBirthNames: Array<string>
  lastModificationDate?: string
  creationDate?: string
  codePeps: string
  advisor?: Advisor
  projectPhase?: NoubaLightProjectProjectPhaseEnum
}

export const NoubaLightProjectProjectPhaseEnum = {
  ANALYSE: "ANALYSE",
  ETUDE: "ETUDE",
  APPRV: "APPRV",
  SUIVI: "SUIVI",
  TERMN: "TERMN",
  ABNDN: "ABNDN",
  REFUS: "REFUS"
} as const

export type NoubaLightProjectProjectPhaseEnum =
  (typeof NoubaLightProjectProjectPhaseEnum)[keyof typeof NoubaLightProjectProjectPhaseEnum]
